import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

export default function DetailSection({ title, children }) {
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      {title && (
        <CardContent sx={{ pb: 0 }}>
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
        </CardContent>
      )}
      <CardContent>{children}</CardContent>
    </Card>
  );
}
